import { reportError } from '~/telemetry/datadog_tracer';

// Leaves out 0/O and 1/I so a reference reads unambiguously from a screenshot. The 32 characters
// divide 256 evenly, so picking by `byte % length` stays uniform.
const SSO_REFERENCE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const SSO_REFERENCE_PATTERN = /^[A-HJ-NP-Z2-9]{4}-[A-HJ-NP-Z2-9]{4}$/;

export function createSsoReference(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(8));
  const characters = Array.from(bytes, (byte) => SSO_REFERENCE_ALPHABET[byte % SSO_REFERENCE_ALPHABET.length]);
  return `${characters.slice(0, 4).join('')}-${characters.slice(4).join('')}`;
}

export function isSsoReference(value: unknown): value is string {
  return typeof value === 'string' && SSO_REFERENCE_PATTERN.test(value);
}

type ReportSsoFailureArgs = {
  reference: string;
  clientId?: string;
  error?: string;
  errorDescription?: string;
};

export function reportSsoFailure({ reference, clientId, error, errorDescription }: ReportSsoFailureArgs): void {
  reportError({
    error: new Error('SSO sign-in returned without a token'),
    context: {
      ssoReference: reference,
      ssoClientId: clientId,
      ssoError: error,
      ssoErrorDescription: errorDescription,
    },
  });
}
